import { render, staticRenderFns } from "./creatAttr.vue?vue&type=template&id=97283974&scoped=true"
import script from "./creatAttr.vue?vue&type=script&lang=js"
export * from "./creatAttr.vue?vue&type=script&lang=js"
import style0 from "./creatAttr.vue?vue&type=style&index=0&id=97283974&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97283974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97283974')) {
      api.createRecord('97283974', component.options)
    } else {
      api.reload('97283974', component.options)
    }
    module.hot.accept("./creatAttr.vue?vue&type=template&id=97283974&scoped=true", function () {
      api.rerender('97283974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/pointsMall/components/creatAttr.vue"
export default component.exports